var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrows_1_",
    "data-name": "arrows(1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12.932,
    viewBox: "0 0 16 12.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M.236,53.52l6.671-4.339a.522.522,0,0,1,.806.437v2.248a9.147,9.147,0,0,1,7.426,6.544l.84,2.953a.522.522,0,0,1-.909.469c-2.178-2.724-3.62-5.1-7.357-5.606V58.3a.522.522,0,0,1-.806.437L.237,54.394A.522.522,0,0,1,.236,53.52Z",
    transform: "translate(0.001 -49.096)",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.97ac1b9b38f306043ebbfa9f6b32d014.svg";
export { ForwardRef as ReactComponent };